import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Container,
  Row,
  Col,
  Badge,
  Button,
} from "reactstrap";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getJournalApi, deleteJournalApi } from "src/network/api";
import PageLayout from "./PageLayout";
import Pagination from "./components/Pagination";

const ManageJournals = () => {
  const [journals, setJournals] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const navigate = useNavigate();
  useEffect(() => {
    const fetchJournals = async () => {
      try {
        const response = await getJournalApi();

        const formattedJournals = response.data.map((journal) => ({
          id: journal.journal_id,
          journalName: journal.journal_name,
          eissnNo: journal.eissn_no,
          publisherName: journal.publisher_name,
          reviewType: journal.review_type,
          approvalStatus: journal.status === "0" ? "pending" : "approved",
        }));
        setData(response?.data);

        setJournals(formattedJournals);
      } catch (error) {
        console.error("Failed to fetch journals:", error);
        setLoading(true);
        const errorMessage =
          error?.response?.data?.message || "Failed to fetch journal records!";
        toast.error(errorMessage);
      }
    };

    fetchJournals();
  }, []);

  const handleDelete = async (journalId) => {
    try {
      const response = await deleteJournalApi(journalId);

      if (response.status === 200) {
        toast.success(
          response?.data?.message || "Journal deleted successfully!"
        );

        setJournals(journals.filter((journal) => journal.id !== journalId));
      } else {
        toast.error(response?.data?.message || "Failed to delete the journal.");
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        "An unexpected error occurred while deleting the journal.";
      toast.error(errorMessage);
    }
  };

  const handleNavigateToEdit = (journal) => {
    navigate(`/edit-journal/${journal.journal_id}`);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "approved":
        return (
          <Badge color="success" className="text-white px-3 py-2 h5">
            Approved
          </Badge>
        );
      case "pending":
        return (
          <Badge color="warning" className="text-white px-3 py-2 h5">
            Pending
          </Badge>
        );
      case "rejected":
        return (
          <Badge color="danger" className="text-white px-3 py-2 h5">
            Rejected
          </Badge>
        );
      default:
        return (
          <Badge color="secondary" className="text-white px-3 py-2 h5">
            Unknown
          </Badge>
        );
    }
  };
  return (
    <PageLayout>
      <div className="mt-5 mb-7 container-fluid">
        <Row className="justify-content-center">
          <Col lg="12" md="10" sm="8" xs="12">
            <Card className="shadow">
              <CardHeader className="bg-primary">
                <h3 className="mb-0 text-center font-weight-bold text-white">
                  Manage Journals
                </h3>
              </CardHeader>
              <CardBody>
                {loading ? (
                  <p>Loading journals...</p>
                ) : (
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Journal Name</th>
                        <th scope="col">Journal Image</th>
                        <th scope="col">EISSN No</th>
                        <th scope="col">Publisher Name</th>
                        <th scope="col">Review Type</th>
                        <th scope="col">Approval Status</th>
                        <th scope="col">Delete</th>
                        <th scope="col">Edit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((journal, index) => (
                          <tr key={index}>
                            <td>{journal.journal_name}</td>
                            <td>
                              <img
                                src={journal.image}
                                alt={journal.image}
                                style={{ width: "100px", height: "100px" }}
                              />
                            </td>
                            <td>{journal.eissn_no}</td>
                            <td>{journal.publisher_name}</td>
                            <td>{journal.review_type}</td>
                            <td>{getStatusBadge(journal.approval_status)}</td>
                            <td>
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => handleDelete(journal.journal_id)}
                              >
                                <FaTrashAlt />
                              </Button>
                            </td>
                            <td>
                              <Button
                                color="info"
                                size="sm"
                                onClick={() => handleNavigateToEdit(journal)}
                              >
                                <FaEdit />
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8} className="text-center py-4">
                            <strong>No publications found.</strong>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </PageLayout>
  );
};

export default ManageJournals;
